// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.contact-image {
  width: 80px;
  height: 83px;
}

.chrome-image {
  width: 50px;
  margin-top: 5px;
}

.edge-image {
  width: 45px;
  margin-top: 5px;
}

.edge-chromium-image {
  width: 50px;
  margin-top: 5px;
  margin-left: 3px;
}

.contact {
  display: flex;
}

.ci-logo {
  width: 50%;
}

.gallery {
  max-width: 80px;
}

.top-div {
  text-align: center;
  width: 100%;
}

.center-div {
  width: 100%;
  display: inline-block;
}

.banner {
  width: 100%;
  margin: 0 auto;
}

.support-person {
  margin-left: 10px;
  margin-bottom: 10px;
  text-align: left;
}

.link-style {
  margin-left: 40px;
  margin-bottom: 10px;
  text-align: left;
}

.third-col {
  margin-top: 1em;
  text-align: left;
  width: 91%;
  display: inline-block;
}

.second-col {
  margin-top: 1em;
  text-align: left;
  width: 91%;
  display: inline-block;
}

.first-col {
  margin-top: 1em;
  width: 91%;
  display: inline-block;
}

.align-center {
  text-align: center;
  width: 100%;
}

.section-header {
  text-align: left;
  font-weight: bold;
}

.bottom-divider {
  margin-bottom: 70px;
}

.info {
  margin-bottom: 5px;
  text-align: left;
  margin-top: 10px;
}

.label {
  margin-bottom: 10px;
  text-align: left;
  margin-top: 20px;
}

.vertical-divider {
  border-right: 1px lightgrey solid;
}

.bullet-list {
  text-align: left;
}

.center-content {
  text-align: center;
}

.banner-div {
  padding: 10px 0 0 0;
  border-bottom: none;
  box-shadow: none;
}

.content-div {
  padding: 10px 0 0 0;
  border-bottom: none;
  box-shadow: none;
}

.links {
  font-style: italic;
}

.linkDescription {
  font-style: italic;
}

.align-left {
  text-align: left;
}

.space-top {
  margin-top: 40px;
}

.column {
  width: 90%;
  text-align: center;
}

.image-gallery {
  width: 100%;
  height: 350px;
}

.mat-mdc-button {
  min-width: 0px;
  width: 18px;
  padding: 0px;
}

.banner-lime {
  background-color: #adff2f;
  width: 100%;
  text-align: center;
  padding: 10px 0;
  color: black;
  font-size: 20px;
}
/*# sourceMappingURL=data:application/json;base64,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 */`, "",{"version":3,"sources":["webpack://./src/app/components/homepage/homepage.component.scss"],"names":[],"mappings":"AAAA;EACE,WAAA;EACA,YAAA;AACF;;AAEA;EACE,WAAA;EACA,eAAA;AACF;;AAEA;EACE,WAAA;EACA,eAAA;AACF;;AAEA;EACE,WAAA;EACA,eAAA;EACA,gBAAA;AACF;;AAEA;EACE,aAAA;AACF;;AAEA;EACE,UAAA;AACF;;AAEA;EACE,eAAA;AACF;;AAEA;EACE,kBAAA;EACA,WAAA;AACF;;AAEA;EACE,WAAA;EACA,qBAAA;AACF;;AACA;EACE,WAAA;EACA,cAAA;AAEF;;AACA;EACE,iBAAA;EACA,mBAAA;EACA,gBAAA;AAEF;;AACA;EACE,iBAAA;EACA,mBAAA;EACA,gBAAA;AAEF;;AACA;EACE,eAAA;EACA,gBAAA;EACA,UAAA;EACA,qBAAA;AAEF;;AACA;EACE,eAAA;EACA,gBAAA;EACA,UAAA;EACA,qBAAA;AAEF;;AACA;EACE,eAAA;EACA,UAAA;EACA,qBAAA;AAEF;;AACA;EACE,kBAAA;EACA,WAAA;AAEF;;AACA;EACE,gBAAA;EACA,iBAAA;AAEF;;AACA;EACE,mBAAA;AAEF;;AACA;EACE,kBAAA;EACA,gBAAA;EACA,gBAAA;AAEF;;AACA;EACE,mBAAA;EACA,gBAAA;EACA,gBAAA;AAEF;;AACA;EACE,iCAAA;AAEF;;AACA;EACE,gBAAA;AAEF;;AACA;EACE,kBAAA;AAEF;;AACA;EACE,mBAAA;EACA,mBAAA;EACA,gBAAA;AAEF;;AACA;EACE,mBAAA;EACA,mBAAA;EACA,gBAAA;AAEF;;AACA;EACE,kBAAA;AAEF;;AACA;EACE,kBAAA;AAEF;;AACA;EACE,gBAAA;AAEF;;AACA;EACE,gBAAA;AAEF;;AACA;EACE,UAAA;EACA,kBAAA;AAEF;;AACA;EACE,WAAA;EACA,aAAA;AAEF;;AACA;EACE,cAAA;EACA,WAAA;EACA,YAAA;AAEF;;AACA;EACE,yBAAA;EACA,WAAA;EACA,kBAAA;EACA,eAAA;EACA,YAAA;EACA,eAAA;AAEF;AACA,o/IAAo/I","sourcesContent":[".contact-image {\n  width: 80px;\n  height: 83px;\n}\n\n.chrome-image {\n  width: 50px;\n  margin-top: 5px;\n}\n\n.edge-image {\n  width: 45px;\n  margin-top: 5px;\n}\n\n.edge-chromium-image {\n  width: 50px;\n  margin-top: 5px;\n  margin-left: 3px;\n}\n\n.contact {\n  display: flex;\n}\n\n.ci-logo {\n  width: 50%;\n}\n\n.gallery {\n  max-width: 80px;\n}\n\n.top-div {\n  text-align: center;\n  width: 100%;\n}\n\n.center-div {\n  width: 100%;\n  display: inline-block;\n}\n.banner {\n  width: 100%;\n  margin: 0 auto;\n}\n\n.support-person {\n  margin-left: 10px;\n  margin-bottom: 10px;\n  text-align: left;\n}\n\n.link-style {\n  margin-left: 40px;\n  margin-bottom: 10px;\n  text-align: left;\n}\n\n.third-col {\n  margin-top: 1em;\n  text-align: left;\n  width: 91%;\n  display: inline-block;\n}\n\n.second-col {\n  margin-top: 1em;\n  text-align: left;\n  width: 91%;\n  display: inline-block;\n}\n\n.first-col {\n  margin-top: 1em;\n  width: 91%;\n  display: inline-block;\n}\n\n.align-center {\n  text-align: center;\n  width: 100%;\n}\n\n.section-header {\n  text-align: left;\n  font-weight: bold;\n}\n\n.bottom-divider {\n  margin-bottom: 70px;\n}\n\n.info {\n  margin-bottom: 5px;\n  text-align: left;\n  margin-top: 10px;\n}\n\n.label {\n  margin-bottom: 10px;\n  text-align: left;\n  margin-top: 20px;\n}\n\n.vertical-divider {\n  border-right: 1px lightgrey solid;\n}\n\n.bullet-list {\n  text-align: left;\n}\n\n.center-content {\n  text-align: center;\n}\n\n.banner-div {\n  padding: 10px 0 0 0;\n  border-bottom: none;\n  box-shadow: none;\n}\n\n.content-div {\n  padding: 10px 0 0 0;\n  border-bottom: none;\n  box-shadow: none;\n}\n\n.links {\n  font-style: italic;\n}\n\n.linkDescription {\n  font-style: italic;\n}\n\n.align-left {\n  text-align: left;\n}\n\n.space-top {\n  margin-top: 40px;\n}\n\n.column {\n  width: 90%;\n  text-align: center;\n}\n\n.image-gallery {\n  width: 100%;\n  height: 350px;\n}\n\n.mat-mdc-button {\n  min-width: 0px;\n  width: 18px;\n  padding: 0px;\n}\n\n.banner-lime {\n  background-color: #adff2f;\n  width: 100%;\n  text-align: center;\n  padding: 10px 0;\n  color: black;\n  font-size: 20px;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
